<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chapnum"><a id="page_9">BAD SANTA</a></h2><a id="page_9">
</a><p class="noindent"><a id="page_9"></a><a id="page_10">He knows when you are sleeping, he knows when you’re awake, he knows when is the best time to thieve from department stores so answer these questions for goodness’ sake … Yes, folks, it’s everyone’s favourite anti-Christmas movie. Billy Bob Thornton is brilliantly cast as the drunken, potty-mouthed safecracker under not-so-deep cover as a department store Santa. With a bunch of laughs, some splendid action scenes, a fair chunk of tugs-at-the-heart-strings and the unlikely-but-inevitable final redemption, <em class="italic">Bad Santa</em> is very much a modern Chrimbo movie. If you’re sick of schmaltziness and snow-covered scenes of lovey-dovey Xmas films, this is an ideal way to re-set the heart-clock. But how well do you know the movie? Let’s dive right in …</a></p><a id="page_10">
</a><h3 class="title"><a id="page_10"></a><a id="page_11">20 Questions</a></h3><a id="page_11">
<p class="list"><span class="list">1.</span> What is the scheme that Willie T. Soke and Marcus Skidmore put into play every year?</p>
<p class="list"><span class="list">2.</span> And who is the third member of the team?</p>
<p class="list"><span class="list">3.</span> What is the name of the manager of the mall in Saguaro Square, who Willie’s foul mouth offends?</p>
<p class="list"><span class="list">4.</span> What attracts Willie to Sue at the bar?</p>
<p class="list"><span class="list">5.</span> What does Thurman Merman say his dad Roger was doing?</p>
<p class="list"><span class="list">6.</span> But where is Roger really?</p>
<p class="list"><span class="list">7.</span> Why does Willie end up moving into Thurman’s house?</p>
<p class="list"><span class="list">8.</span> What gift did Thurman request from Santa, and what does he change it to?</p>
<p class="list"><span class="list">9.</span> And what have the bullies done to him?</p>
<p class="list"><span class="list">10.</span> What does Willie give Thurman, and why?</p>
<p class="list"><span class="list">11.</span> What present does Thurman give Willie?</p>
<p class="list"><span class="list">12.</span> What does Gin demand from Willie and Marcus?</p>
<p class="list"><span class="list">13.</span> But what drastic step do Marcus and Lois take?</p>
<p class="list"><span class="list">14.</span> How does Thurman respond when Willie tells him that he is not actually Santa?</p>
<p class="list"><span class="list">15.</span> What does Marcus reveal that he was planning to do to Willie?</p>
</a><p class="list"><a id="page_11"><span class="list">16.</span> </a><a id="page_12">What does Willie grab as he makes his escape?</a></p><a id="page_12">
<p class="list"><span class="list">17.</span> But what happens just before he can reach Thurman's front door?</p>
<p class="list"><span class="list">18.</span> Why is Willie found innocent?</p>
<p class="list"><span class="list">19.</span> And what will Willie’s new job be?</p>
<p class="list"><span class="list">20.</span> What is Sue’s new role at the end?</p>
</a><p class="noindent1a"><a id="page_12"><em class="italic">Answers on </em></a><span href="#/xhtml/44_Chapter41#page_266" title="Link target outside of Sample">page 266</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Chapter02.vue?5a70df12